/* tslint:disable */
/* eslint-disable */
/**
 * NameCheck API
 * assembly version: 1.0.0.0
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NameCheckDataDto,
    NameCheckDataDtoFromJSON,
    NameCheckDataDtoFromJSONTyped,
    NameCheckDataDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface NameCheckDataDtoPaginatedResultDto
 */
export interface NameCheckDataDtoPaginatedResultDto {
    /**
     * 
     * @type {number}
     * @memberof NameCheckDataDtoPaginatedResultDto
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof NameCheckDataDtoPaginatedResultDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof NameCheckDataDtoPaginatedResultDto
     */
    total?: number;
    /**
     * 
     * @type {Array<NameCheckDataDto>}
     * @memberof NameCheckDataDtoPaginatedResultDto
     */
    results?: Array<NameCheckDataDto> | null;
}

export function NameCheckDataDtoPaginatedResultDtoFromJSON(json: any): NameCheckDataDtoPaginatedResultDto {
    return NameCheckDataDtoPaginatedResultDtoFromJSONTyped(json, false);
}

export function NameCheckDataDtoPaginatedResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NameCheckDataDtoPaginatedResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'take': !exists(json, 'take') ? undefined : json['take'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(NameCheckDataDtoFromJSON)),
    };
}

export function NameCheckDataDtoPaginatedResultDtoToJSON(value?: NameCheckDataDtoPaginatedResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'take': value.take,
        'page': value.page,
        'total': value.total,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(NameCheckDataDtoToJSON)),
    };
}


